import { verificationsApi } from '../../../data/verificationsApi';
import type { AgentDashboardWorklistItem } from './agentDashboardViews';

/**
 * agentDashboard feature endpoints, injected into the single verifications base api.
 *
 * Owns the agent benefits worklist read. The endpoint is feature-owned (not shared); other modules
 * that need this read inject their own copy under a distinct name on their module base api (e.g. the
 * agents module's `agentsVerificationsApi`).
 */
export const agentDashboardEndpoints = verificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentDashboardWorklist: builder.query<
      AgentDashboardWorklistItem[],
      { company: string }
    >({
      query: ({ company }) => ({
        url: '/verification/agent-dashboard/worklist',
        method: 'GET',
        params: { company },
      }),
      providesTags: (result, error, { company }) => [
        { type: 'AgentDashboardWorklist', id: company },
        'AgentDashboardWorklist',
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAgentDashboardWorklistQuery } = agentDashboardEndpoints;
